// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"f85548040e1853f2b590","691":"afa6474dde5340bf5317"}[chunkId] + ".js";
};